import { getImageUrl, getImageUrls } from '@/utils/image'

export default {
    methods: {
        getImageUrl,
        getImageUrls
    }
}